import { Command, Info, LogOut, MessageCircleQuestion } from 'lucide-react'

import { FeedbackDialog } from '~/components/FeedbackDialog'
import { ShortcutsDialog } from '~/components/ShortcutsDialog'
import { CommandProps } from '~/components/command-menu/types'
import { DOCS_URL } from '~/constants/externalUrls'
import { sendTrackingData } from '~/utils/tracking'

export const helpCommands: CommandProps[] = [
  {
    category: 'help',
    label: () => 'Contact us',
    value: () => 'Help - Contact',
    icon: () => <MessageCircleQuestion />,
    onSelect: ({ actions: { setGlobalModalState, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'help',
        item: 'contact_us',
      })

      setGlobalModalState({
        isOpen: true,
        content: (
          <FeedbackDialog
            closeDialog={() => {
              setGlobalModalState({ isOpen: false, content: null })
            }}
          />
        ),
      })

      setActiveView(null)
    },
    shortcuts: ['o > c'],
  },
  {
    category: 'help',
    label: () => 'Open docs',
    value: () => 'Help - Docs',
    icon: () => <Info />,
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'help',
        item: 'open_docs',
      })

      navigate(DOCS_URL, { target: 'tab' })
      setActiveView(null)
    },
    shortcuts: ['o > d', 'o > g'],
  },
  {
    category: 'help',
    label: () => 'View all shortcuts',
    value: () => 'Help - Shortcuts',
    icon: () => <Command />,
    onSelect: ({ actions: { setGlobalModalState, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'help',
        item: 'view_shortcuts',
      })

      setGlobalModalState({
        isOpen: true,
        content: <ShortcutsDialog />,
      })
      setActiveView(null)
    },
    shortcuts: ['slash'],
  },
  {
    category: 'help',
    label: () => 'Log out',
    value: () => 'Help - Logout',
    icon: () => <LogOut />,
    onSelect: ({ actions: { logout, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'help',
        item: 'log_out',
      })

      logout()
      setActiveView(null)
    },
  },
]
